import React, { Component } from 'react';
import { View, LayoutAnimation, UIManager } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { SectionHeader, VFButton } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import ChangeDeviceNameModal from '../../../CommonUI/ChangeDeviceName';
import { getThemeImages } from '../../../Themes';
import DeviceInfo from '../DeviceInfo';
import ShowMore from '../ShowMore';
import ShowMoreContent from '../ShowMoreContent';

import styles from './CurrentDeviceCard.Styles';

const CustomLayoutAnimation = {
  duration: 150,
  create: {
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
  },
};

class CurrentDeviceCard extends Component {
  state = {
    isShowMoreOpened: false,
    isChangeDeviceNameModalVisible: false,
  };

  onChangeDeviceNamePress = () => {
    this.setState(prevState => {
      return {
        isChangeDeviceNameModalVisible: !prevState.isChangeDeviceNameModalVisible,
      };
    });
  };

  onShowMorePress = () => {
    UIManager.setLayoutAnimationEnabledExperimental &&
      UIManager.setLayoutAnimationEnabledExperimental(true);
    LayoutAnimation.configureNext(CustomLayoutAnimation);
    this.setState(state => ({ isShowMoreOpened: !state.isShowMoreOpened }));
  };

  renderDeviceName = () => {
    const { theme, onMobileNameChange, mobileName } = this.props;
    const images = getThemeImages(theme.name);

    return (
      <>
        <SectionHeader
          theme={theme}
          title={mobileName}
          rightIcon={images.edit_pen}
          rightIconSize={20}
          rightText="device_card_edit_name"
          titleStyle={styles.headerTitle}
          onRightSectionPress={this.onChangeDeviceNamePress}
          style={styles.sectionHeaderContainer}
        />
        <View style={styles.divider(theme)} />
        <ChangeDeviceNameModal
          isVisible={this.state.isChangeDeviceNameModalVisible}
          onCloseQuickAction={this.onChangeDeviceNamePress}
          onDeviceNameChange={onMobileNameChange}
        />
      </>
    );
  };

  render() {
    const {
      deviceType,
      deviceTypeAccessibilityLabel,
      deviceName,
      deviceNameAccessibilityLabel,
      deviceExtraInfo,
      deviceExtraInfoTitleStyle,
      deviceExtraInfoSubTitleStyle,
      withShowMore,
      showMoreContent,
      showMoreContentDescriptionStyle,
      showMoreContentDataLabelStyle,
      showMoreContentDataValueStyle,
      image,
      iconSize,
      isUpgradeAvailable,
      onPressUpgradenow,
      theme,
      withDeviceName,
      primaryButtonTitle,
      cardContainerStyle,
    } = this.props;
    const { isShowMoreOpened } = this.state;

    return (
      <View style={[styles.cardContainerStyle(theme), cardContainerStyle]}>
        {withDeviceName && this.renderDeviceName()}
        <DeviceInfo
          name={deviceName}
          type={deviceType}
          image={image}
          iconSize={iconSize}
          extraInfo={deviceExtraInfo}
          extraInfoTitleStyle={deviceExtraInfoTitleStyle}
          extraInfoSubTitleStyle={deviceExtraInfoSubTitleStyle}
          deviceTypeAccessibilityLabel={deviceTypeAccessibilityLabel}
          deviceNameAccessibilityLabel={deviceNameAccessibilityLabel}
        />
        {isUpgradeAvailable && (
          <>
            <View style={styles.divider(theme)} />
            <VFButton
              title={primaryButtonTitle}
              type="primary"
              style={styles.upgradeBtn}
              onPress={onPressUpgradenow}
            />
          </>
        )}
        <ShowMoreContent
          showContent={isShowMoreOpened}
          content={showMoreContent}
          labelStyle={showMoreContentDataLabelStyle}
          valueStyle={showMoreContentDataValueStyle}
          descriptionStyle={showMoreContentDescriptionStyle}
        />
        <ShowMore
          withShowMore={withShowMore}
          onPress={this.onShowMorePress}
          isShowMoreOpened={isShowMoreOpened}
        />
      </View>
    );
  }
}
CurrentDeviceCard.defaultProps = {
  isUpgradeAvailable: true,
  iconSize: 96,
  withDeviceName: true,
  primaryButtonTitle: 'my_device_upgrade_button_title',
};
CurrentDeviceCard.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    }),
  ]),
  withDeviceName: PropTypes.bool,
  primaryButtonTitle: PropTypes.string,
  cardContainerStyle: ViewPropTypes.style,
  iconSize: PropTypes.number,
  deviceType: PropTypes.string,
  deviceTypeAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  deviceName: PropTypes.string,
  deviceNameAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  onPressUpgradenow: PropTypes.func,
  onMobileNameChange: PropTypes.func,
  mobileName: PropTypes.string,
  isUpgradeAvailable: PropTypes.bool,
  image: PropTypes.object,
  deviceExtraInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
  ),
  deviceExtraInfoTitleStyle: TextPropTypes.style,
  deviceExtraInfoSubTitleStyle: TextPropTypes.style,
  withShowMore: PropTypes.bool,
  showMoreContent: PropTypes.shape({
    description: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  showMoreContentDescriptionStyle: TextPropTypes.style,
  showMoreContentDataLabelStyle: TextPropTypes.style,
  showMoreContentDataValueStyle: TextPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(CurrentDeviceCard);
